// extracted by mini-css-extract-plugin
export default {"examPartHeader":"TelcExamTimetable_examPartHeader__I6tTZ"};